//
//
//
//
//
//

export default {
  mounted(){
    this.$vux.toast.show({
      type: "text",
      text: "抱歉，该页面不存在！",
      width: "200px"
    });
    setTimeout(()=>{
      this.$router.push(`/`)
    },2000)
  }
}



// WEBPACK FOOTER //
// ./src/page/notfound.vue